import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { id: "services", label: "Services" },
  { id: "why-us", label: "Why Us" },
  { id: "process", label: "Process" },
  { id: "about", label: "About" },
  { id: "contact", label: "Contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNavClick = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#F4F3EF]/85 border-b border-black/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-5 flex items-center justify-between">
        <a
          href="https://sativabuildingsystems.com/"
          data-testid="brand-link"
          className="flex items-center gap-3 group"
        >
          <div className="w-9 h-9 bg-[#2C4230] flex items-center justify-center">
            <span className="font-display font-black text-[#F4F3EF] text-lg leading-none">S</span>
          </div>
          <div className="leading-tight">
            <div className="font-display font-bold text-[15px] text-[#1A1D1A] tracking-tight">
              Sativa Construction
            </div>
            <div className="text-[10px] tracking-[0.22em] uppercase text-[#9E8262] font-medium">
              Building Systems
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((n) => (
            <button
              key={n.id}
              type="button"
              data-testid={`nav-${n.id}`}
              onClick={() => handleNavClick(n.id)}
              className="text-[13px] font-medium tracking-wide text-[#1A1D1A]/80 hover:text-[#2C4230] transition-colors relative after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-[#2C4230] hover:after:w-full after:transition-all after:duration-300"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            type="button"
            data-testid="header-cta-quote"
            onClick={() => handleNavClick("contact")}
            className="hidden sm:inline-flex bg-[#2C4230] text-[#F4F3EF] hover:bg-[#213124] transition-colors duration-300 px-5 py-3 text-[13px] font-semibold tracking-wide"
          >
            Request a Quote
          </button>
          <button
            type="button"
            data-testid="mobile-menu-toggle"
            aria-label="Open menu"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden p-2 text-[#1A1D1A]"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        data-testid="mobile-menu"
        className={`lg:hidden overflow-hidden transition-[max-height,opacity] duration-500 bg-[#F4F3EF] border-t border-black/5 ${
          open ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="px-6 py-6 flex flex-col gap-4">
          {NAV.map((n) => (
            <button
              key={n.id}
              type="button"
              data-testid={`mobile-nav-${n.id}`}
              onClick={() => handleNavClick(n.id)}
              className="text-left text-[15px] font-medium text-[#1A1D1A] hover:text-[#2C4230] transition-colors"
            >
              {n.label}
            </button>
          ))}
          <button
            type="button"
            data-testid="mobile-cta-quote"
            onClick={() => handleNavClick("contact")}
            className="mt-2 bg-[#2C4230] text-[#F4F3EF] hover:bg-[#213124] transition-colors px-5 py-3 text-[13px] font-semibold tracking-wide self-start"
          >
            Request a Quote
          </button>
        </div>
      </div>
    </header>
  );
};
